import { render } from "./xtx-carousel.vue?vue&type=template&id=00c5530c&scoped=true"
import script from "./xtx-carousel.vue?vue&type=script&lang=js"
export * from "./xtx-carousel.vue?vue&type=script&lang=js"

import "./xtx-carousel.vue?vue&type=style&index=0&id=00c5530c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c5530c"]])

export default __exports__